import { firmQueryKeys } from '../Firm';

export const baaKeys = {
  base: ['baa'],
  baaPersonForSelf: (firmID: string | undefined | null) => [
    ...baaKeys.base,
    'baaPersonForSelf',
    ...firmQueryKeys.identifier(firmID),
  ],
};
